export const RemoveFilters = (userConfig) => {
    localStorage.removeItem(`smartFilters_${userConfig?.userid}_assign-employee`);
    localStorage.removeItem(`smartFilters_${userConfig?.userid}_unassign-summary-table`);
    localStorage.removeItem(`smartFilters_${userConfig?.userid}_crew-summary-table`);
    sessionStorage.removeItem(`assignEmployeeAppliedFilters`);
    sessionStorage.removeItem(`assignEmployeeFilterFormValues`);
};
